import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import Button from '@components/Button';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import usePrepaidCharge from './hooks/usePrepaidCharge';
import usePrepaidRechargeLimits from '../../../_shared/hooks/usePrepaidRechargeLimits';

interface Props {
    id: string;
    agreed: boolean;
}

function PrepaidCardChargeFooter({ id, agreed }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount } = useContext(PrepaidContext);
    const { data } = useQuery(userPrepaidCardQueries.detail(id));
    const { handleCharge, isPending } = usePrepaidCharge(id);
    const balance = data?.balance ?? 0;
    const { getLimitError } = usePrepaidRechargeLimits();
    const isInvalid = amount <= 0 || getLimitError(amount, balance) != null;

    return (
        <Button fullWidth
            onClick={handleCharge}
            disabled={isPending || !data || !agreed || isInvalid}>
            {t('charge.submit')}
        </Button>
    );
}

export default PrepaidCardChargeFooter;
